HHS.components = {};

HHS.components.init = function components_init() {

	log("Initializing Components...");

	HHS.components.initTipped();
	HHS.components.initClearFields();
	HHS.components.initFitVids();
	HHS.components.initFlexSlider();
	HHS.components.initFlexCarousel();
	HHS.components.initSuperMenu();
	HHS.components.initMobileNavClick();
	HHS.components.sitePopUps();
	HHS.components.initVelocity();
	HHS.components.initIsotope();
	HHS.components.initGallery();
	HHS.components.initSite();


};

/**
 * Gallery.
 */
HHS.components.initGallery = function initGallery () {

	$(".gallery").lightGallery({
		thumbnail:true,
		autoplay:false
	});

	$(".slideshow").lightGallery({
		mode:'lg-fade',
		thumbnail:false,
		download:false,
		autoplay:true,
		fullScreen:true,
		zoom:false,
		actualSize:false,
		share:false
	});
}

/**
 * Isotope.
 */
HHS.components.initIsotope = function initIsotope () {

	function getHashFilter() {
		var hash = location.hash;
		//hash = hash.replace(/\/$/g, '');

		// get filter=filterName
		var matches = location.hash.match( /filter=([^&]+)/i );
		var hashFilter = matches && matches[1];
		return hashFilter && decodeURIComponent( hashFilter );
	}

	$( function() {

		// bind filter button click
		var $filters = $('#filter').on( 'click', 'button', function() {
			var filterValue = $( this ).attr('data-filter');
			location.hash = 'filter=' + encodeURIComponent( filterValue );
		});

		var isIsotopeInit = false;

		function onHashchange() {

			var hashFilter = getHashFilter();
			//var hashFilter = location.hash.substring(1);
			if ( !hashFilter && isIsotopeInit ) {
				return;
			}
			isIsotopeInit = true;

			var $grid = $('.adopt-list').isotope({
				itemSelector: '.adopt-animal',
				filter: hashFilter
			});

			// filter isotope
			$grid.imagesLoaded().progress( function() {
			  $grid.isotope('layout');
			});

			// set selected class on button
			if ( hashFilter ) {
				$filters.find('.current').removeClass('current');
				$filters.find('[data-filter="' + hashFilter + '"]').addClass('current');
			}
		}

		$(window).on( 'hashchange', onHashchange );
		// trigger event handler to init Isotope
		onHashchange();
	});
}

/**
 * Tipped Tooltips.
 */
HHS.components.initTipped = function initTipped () {

	Tipped.create('.tipped', {
		maxWidth: 300
	});

	Tipped.create('.tipped-bottom', {
		maxWidth: 300,
		position: 'bottom',
		offset: { y: -25 }
	});

	Tipped.create('.tipped-offset', {
		maxWidth: 300,
		offset: { y: -22 },
		position: 'topleft'
	});

}

/**
 * Clear fields.
 */
HHS.components.initClearFields = function initClearFields () {

	//$('.clearfield').clearField();
	$('input[type="text"], textarea').clearfield({cssClass: 'clearfield'});

}

/**
 * FitVids.
 */
HHS.components.initFitVids = function initFitVids () {

	$(".video-container").fitVids();

}


/**
 * FlexSlider.
 */
HHS.components.initFlexSlider = function initFlexSlider () {

	$('.flexslider')
		.fitVids()
		.flexslider({
			animation: "slide",
			slideshowSpeed:4000,
			directionNav: true,
			animationLoop: true,
			pauseOnHover: true,
			smoothHeight: true
		});

}

/**
 * FlexCarousel.
 */
HHS.components.initFlexCarousel = function initFlexCarousel () {

	// store the slider in a local variable
	var $window = $(window),
		flexslider = { vars:{} };

	// tiny helper function to add breakpoints
	function getGridSize() {
		return (window.innerWidth < 600) ? 2 :
			(window.innerWidth < 900) ? 3 : 4;
	}

	$window.load(function() {
		$('.flexcarousel').flexslider({
			animation: "slide",
			animationLoop: true,
			itemWidth: 210,
			itemMargin: 8,
            directionNav: true,
            controlNav:true,
			minItems: getGridSize(), // use function to pull in initial value
			maxItems: getGridSize(), // use function to pull in initial value
            start: function(slider){
                $('body').removeClass('loading');
                flexslider = slider;
            }
		});
	});

	// check grid size on resize event
	$window.resize(function() {
		var gridSize = getGridSize();

		flexslider.vars.minItems = gridSize;
		flexslider.vars.maxItems = gridSize;
	});

}

/**
 * Super menu.
 */
HHS.components.initSuperMenu = function initSuperMenu () {

	$('#quick-links').superfish({
		cssArrows:false,
		speed:'fast',
		autoArrows:  false
	});

	$('#main-menu').superfish({
		cssArrows:false,
		speed:'fast',
		autoArrows:  false
	});

}

/**
 * Toggle Mobile Nav Sub Menus
 */
HHS.components.initMobileNavClick = function initMobileNavClick () {

	$("li.top-level a").click(function () {
		$(this).next('ul').slideToggle("fast");
	});

}

/**
 * Magnificent PopUps
 */
HHS.components.sitePopUps = function sitePopUps () {

	$('.popup-vimeo').magnificPopup({
		type: 'iframe',
		showCloseBtn: true,
		closeBtnInside: false
	});

	var sitewidth = $( window ).width();
	if (sitewidth > 855) {
		$('a.location').attr('href', '/_inc/_locationhours');
		$('a.location').magnificPopup({
			type: 'iframe',
			showCloseBtn: true,
			closeBtnInside: false
		});
	}

	$('.image-link').magnificPopup({type:'image'});

}

/**
 * Velocity
 */
HHS.components.initVelocity = function initVelocity () {

	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.scrollup-btn').fadeIn();
		} else {
			$('.scrollup-btn').fadeOut();
		}
	});

	$("#scrollup").on("click", function () {
		$("body").velocity("scroll", {
			duration: "normal",
			easing: "ease-out"
		});
	});
}

/**
 * HHS Site Functions.
 */
HHS.components.initSite = function initSite () {

	// MOVED to Google Tag Manager
	//$('.track-event').click(function () {
	//	var title = $(this).data("title");
	//	var cat = $(this).data("cat");

        //log('this is clicked and tracked', title);

    //    HHS.analytics.trackEvent('Button Clicked', cat, title);
	//});

    //Donation page options
    $('#donation-option input[type="radio"]').change(function() {
    	if($('#in_pap').is(':checked'))  {
    		$(".donation-form-hidden").hide('');
    	} else if ($('#in_medical_fund').is(':checked')) {
    		$(".donation-form-hidden").hide('');
    		$(".donation-form-notes").show('');
    	} else if ($('#in_other').is(':checked')) {
    		$(".donation-form-hidden").hide('');
    		$(".donation-form-notes").show('');
    	} else {
    		$(".donation-form-notes").hide('');
	        $(".donation-form-specials").show('');
	    }
    });

	//Shopping Cart fun
	$('a.cart-box').click(function() {
		$(this).parent().next().slideToggle('fast');
		return false;
	});

	//Update the cart billing info form with Select
	$('#payment_method').change(function(){
        $('#checkout_form_content').html( 'Updating...' );
        $('#checkout_form_content').load('/cart/_dynamic_gateway/'+$(this).val());
    });

	//Update the cart billing info form with Radio
	$('input[type="radio"]#pay_cc').click(function() {
		if($(this).is(':checked'))  {
        	$('#checkout_form_content').html( 'Updating...' );
        	$('#checkout_form_content').load('/cart/_dynamic_gateway/'+$(this).val());
		}
	});
	$('input[type="radio"]#pay_chk').click(function() {
		if($(this).is(':checked'))  {
        	$('#checkout_form_content').html( 'Updating...' );
        	$('#checkout_form_content').load('/cart/_dynamic_gateway/'+$(this).val());
		}
	});

	//AJAX add to cart validate and submit
	$('.add_to_cart_form').each(function(){
		$(this).validate({
	         submitHandler: function(form) {
	           $(form).ajaxSubmit({
	           		beforeSubmit: function() {
	           			$('#add-action').show();
						$('#success-note').velocity({
							backgroundColorAlpha: 100
						});
					},
	                success: function() {
						$('#success-note').html( 'Successfully added to your cart<br /><a class="button" href="/cart/">View Cart</a>' ).show();
						$('#success-note').velocity("scroll");
						$('#success-note').velocity({
							backgroundColorAlpha: 0
						}, 2500);
						$('#add-action').hide();
						$('#tools-cart').load('/cart/_load_cart_total');
                	}
	           });
	         }
		});
    });

	//AJAX form validation - fancy!
	$('#freeform').validate({
         submitHandler: function(form) {
           $(form).ajaxSubmit({
           		beforeSubmit: function() {
           			$('#add-action').show();
				},
                success: function() {
                    $('#freeform').hide();
                    $('#success-note').html( 'Thank you! Your information has been submitted.').show();
					$('#success-note').velocity("scroll");
						$('#success-note').velocity({
							backgroundColorAlpha: 0
						}, 2500);
					$('#add-action').hide();
				},
			   error: function (jqXHR, exception) {
					var msg = '';
					if (jqXHR.status === 0) {
						msg = 'Not connect.\n Verify Network.';
					} else if (jqXHR.status == 404) {
						msg = 'Requested page not found. [404]';
					} else if (jqXHR.status == 500) {
						msg = 'Internal Server Error [500].';
					} else if (exception === 'parsererror') {
						msg = 'Requested JSON parse failed.';
					} else if (exception === 'timeout') {
						msg = 'Time out error.';
					} else if (exception === 'abort') {
						msg = 'Ajax request aborted.';
					} else {
						msg = 'Uncaught Error.\n' + jqXHR.responseText;
					}
					log(msg);
			   }
           });
         }
    });

    $('#freeform-email').validate({
         submitHandler: function(form) {
           $(form).ajaxSubmit({
           		beforeSubmit: function() {
           			$('#add-action').show();
				},
                success: function() {
                    $('#freeform-email').hide();
                    $('#success-note').html( 'Thank you! Your email has been sent.').show();
					$('#success-note').velocity("scroll");
						$('#success-note').velocity({
							backgroundColorAlpha: 0
						}, 2500);
					$('#add-action').hide();
				}
           });
         }
    });

	$('#email-subscribe').validate();
	$('#cart_checkout').validate();
	$('.memorial-form').validate();
	$('#application').validate();
	$('#sponsor-form-submit').validate({
		rules: {
			price: {
				required: true,
				min: 50,
				number: true
			},
			purch_fname: {
				required: true,
				min: 2,
				lettersonly: true
			},
			purch_lname: {
				required: true,
				min: 2,
				lettersonly: true
			}
		}
	});

	$("#email-pap").hide();
	$('#email-btn').click(function() {
		$('#email-pap').slideToggle('fast');
	});

	//Save form information in case user leaves these pages
	$('#application, #cart_checkout', '#sponsor-frm', '#sf-form').sisyphus({timeout: 0});

    //Sponsor Form load thumbnail image
	$('#animal-select').change(function() {
        $("input#animal-name").val($('select#animal-select option:selected').attr('title'));
        $("input#animal-id").val($('select#animal-select option:selected').attr('id'));

        $("input[type='radio']").prop('checked', false);
        var entry = $('select#animal-select option:selected').val();

        $("#animal-photo").show();
        $("#animal-photo").load(('/_inc/_animal-photo/' + entry), function() {
			$("span#adopt_names").html($('select#animal-select option:selected').attr('title'));
			$("span#adopt_id").html($('select#animal-select option:selected').attr('id'));
		});
	});

	//Adoption Sponsor Form
	$('#sponsor-choose input[type="radio"]').change(function() {
        $("input#animal-name").val('');
        $("input#animal-id").val('');
        $('select#animal-select').val('');
        $("#animal-photo").hide();
    });

	$('#sponsor-occasion').change(function() {
		var entry = $('#sponsor-occasion option:selected').val();

		if((entry == 'birthday') || (entry == 'anniversary') || (entry == 'holidays') || (entry == 'other'))  {
    		$(".donation-form-hidden").hide('');
    	} else {
    		$(".donation-form-hidden").hide('');
	        $(".donation-form-specials").show('');
	    }
	});


	//Sponsor Form - copy over the Purchaser info to the Cart Customer Info
    $('#purch_fname').on('blur', function() {
    	var thefirstname = ($('#purch_fname').val());
    	$.cookie('cart_first_name', thefirstname, {path: '/'});
		$("#spon_fname").val(thefirstname);
	});
	$('#cart_checkout input#first_name').val($.cookie('cart_first_name'));
    $('#purch_lname').on('blur', function() {
		var thelastname = ($('#purch_lname').val());
		$.cookie('cart_last_name', thelastname, {path: '/'});
		$("#spon_lname").val(thelastname);
	});
	$('#cart_checkout input#last_name').val($.cookie('cart_last_name'));

 	//Sponsor Form selection tree
	$('input[type="radio"]#gift_option_y').click(function() {
		if($(this).is(':checked'))  {
			$("#spon_fname").val('');
			$("#spon_lname").val('');
			$("#gift-rows").show();
		}
	});
	$('input[type="radio"]#gift_option_n').click(function() {
		if($(this).is(':checked'))  {
			$("#spon_fname").val($('#purch_fname').val());
			$("#spon_lname").val($('#purch_lname').val());
			$("#gift-rows").hide();
		}
	});

	$('#recog_cert').change(function () {
		$('#cert-rows').toggle(this.checked);
	}).change();

	$('input[type="radio"].mail-cert-to').on("click", function () {
    	var showOrHide = ($(this).val() == 'Recipient') ? true : false;
    	$('#cert-rows-recip').toggle(showOrHide);
	});

	//Adoption Application load thumbnail
	$('#animal-select-ado').change(function() {
		var ado_title = $('select#animal-select-ado option:selected').attr('title');
		var ado_id = $('select#animal-select-ado option:selected').attr('id');
        $("input#animal_specific").val(ado_title + ' (' + ado_id + ')' );

        var entry = $('select#animal-select-ado option:selected').val();
        $("#animal-photo-ado").show();
        $("#animal-photo-ado").load('/_inc/_animal-photo/' + entry);
	});

	$('input[type="radio"]#choose_else').click(function() {
		if($(this).is(':checked'))  {
			$("#gift-rows2").show();
		}
	});
	$('input[type="radio"]#choose_me').click(function() {
		if($(this).is(':checked'))  {
			$("#gift-rows2").hide();
		}
	});

	//Memorial Bricks character limiter
	var characters = 20;
	$('.limit').each(function(){
	    $(this).next().append("<strong>"+  characters+"</strong> characters remaining");
	    $(this).keyup(function(){
	        if($(this).val().length > characters){
	        $(this).val($(this).val().substr(0, characters));
	        }
	    	var remaining = characters -  $(this).val().length;
	    	$(this).next().html("<strong>"+  remaining+"</strong> characters remaining");
		});
	});

	//Copy Billing info to Shipping info for silly Paypal
	$("input#cart_checkout").click(function(){
        // Checked, copy values
        $("input#shipping_first_name").val($("input#first_name").val());
        $("input#shipping_last_name").val($("input#last_name").val());
        $("input#shipping_address").val($("input#address").val());
        $("input#shipping_address2").val($("input#address2").val());
        $("input#shipping_city").val($("input#city").val());
        $("input#shipping_state").val($("input#state").val());
        $("input#shipping_zip").val($("input#zip").val());
    });

	//Calendar Nav Jump
	$('#cal-change').change(function() {
		var $vn = $('#cal-change').val();
		window.location=$vn;
	});

	$( "#gala-form #quantity" ).blur(function() {
		$("#continue-btn").removeClass('hidden').show();
	});

}